import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {APIClient} from "../../utils/APIClient";
import {InviteCRMUserModal} from "../invitations/InviteCRMUserModal";
import {ClientTabs} from "./ClientTabs";
import {CRMUsersTable} from "./CRMUsersTable";
import {Button} from 'reactstrap';
import {withRouterParams} from "../../utils/withRouterParams";


class ClientCRMUsers extends Component {

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <CRMUsersContent clientId={this.props.match.params.id}/>
            </div>
        )
    }
}

class CRMUsersContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: null,
            businessUnits: [],
            name: '',
            webhook: '',
        };
        this.handleNewUserWasInvited = this.handleNewUserWasInvited.bind(this);
        this.redirectToCRM = this.redirectToCRM.bind(this);
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    componentDidMount() {
        this.updateTeam();
        this.updateClientData();
    }

    redirectToCRM() {
        window.location = `/crm/${this.props.clientId}`;
    }

    updateClientData() {
        new APIClient(this.updateClientDataURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    name: response.data.name,
                    businessUnits: response.data.business_units
                });
            }
        })
    }

    updateClientDataURL() {
        return API_URL + 'client/' + this.props.clientId;
    }

    updateTeam() {
        new APIClient(this.teamUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR_NO_AGENCY') {
                alert(response.error_message);
                this.redirectToAgencyRegisterPage()
            } else if (response.status === 'OK') {
                this.setState({
                    webhook: response.data.webhook,
                    users: response.data.users,
                });
            }
        })
    }

    teamUrl() {
        return `${API_URL}client/${this.props.clientId}/crm-users/`;
    }

    handleNewUserWasInvited() {
        this.updateTeam();
    }

    render() {
        return (
            <section className="section-content">
                <header className="section-header">
                    <h1 className="section-title">{this.state.name}</h1>
                </header>
                <ClientTabs clientId={this.props.clientId}/>
                <div className="section-body flex h-items">
                    <div className="section-body-item  -half box">
                        <header className="box-header">
                            <h2 className="box-title">Users</h2>
                            <InviteCRMUserModal clientId={this.props.clientId}
                                                onUserInvited={this.handleNewUserWasInvited}/>
                        </header>
                        {this.renderTeam()}
                    </div>
                    <div className="section-body-item -half box">
                        <header className="box-header">
                            <h2 className="box-title">Webhook</h2>
                        </header>
                        <a href={this.state.webhook}>{this.state.webhook}</a>
                    </div>
                    {this.renderCRMButton()}
                </div>
            </section>
        )
    }

    renderCRMButton() {
        return <div className="section-body-item -half -button-container box">
            <Button onClick={this.redirectToCRM} className="-alt">GO TO CRM
            </Button>
        </div>;
    }

    renderTeam() {
        if (this.state.users !== null) {
            return <CRMUsersTable users={this.state.users}/>
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }
}


export default withRouterParams(ClientCRMUsers);